"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoriesFacetNavigation = void 0;
const react_1 = __importStar(require("react"));
const ramda_1 = require("ramda");
const react_redux_1 = require("react-redux");
const localization_1 = require("../../../../localization");
const tree_navigation_1 = require("../../tree-navigation");
const store_1 = require("../../../../store");
const const_1 = require("../../../../store/const");
const utils_1 = require("../../../../utils");
const CategoriesFacetNavigation = ({ expandOverride, debouncedSearchTerm, isSimple, }) => {
    const includedCategoriesIds = (0, store_1.useProductsIncludedCategoriesIds)();
    const excludedCategoriesIds = (0, store_1.useProductsExcludedCategoriesIds)();
    const allCategories = (0, store_1.useAllCategoriesSelector)();
    const topLevelCategories = (0, store_1.useTopLevelCategoriesSelector)();
    const categoriesMap = (0, store_1.useCategoriesMapSelector)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const changeIds = (0, react_1.useCallback)((selectedId, prevCategoriesIds) => {
        const selectedCategoriesIds = [selectedId];
        return (0, ramda_1.all)((selectedCategoryId) => prevCategoriesIds.includes(selectedCategoryId), selectedCategoriesIds)
            ? (0, ramda_1.without)(selectedCategoriesIds)
            : (0, ramda_1.concat)(selectedCategoriesIds);
    }, []);
    const handleSetInclude = (0, react_1.useCallback)((selectedId) => {
        const changeIncludedCategoriesIds = changeIds(selectedId, includedCategoriesIds);
        (0, ramda_1.pipe)(changeIncludedCategoriesIds, ramda_1.uniq, store_1.productsSetIncludedCategoriesIds, dispatch)(includedCategoriesIds);
    }, [dispatch, includedCategoriesIds, changeIds]);
    const handleSetExclude = (0, react_1.useCallback)((selectedId) => {
        const changeExcludedCategoriesIds = changeIds(selectedId, excludedCategoriesIds);
        (0, ramda_1.pipe)(changeExcludedCategoriesIds, ramda_1.uniq, store_1.productsSetExcludedCategoriesIds, dispatch)(excludedCategoriesIds);
    }, [dispatch, excludedCategoriesIds, changeIds]);
    const hierarchalTree = (0, react_1.useMemo)(() => (0, utils_1.getTreeData)(allCategories, (item) => item.title), [allCategories]);
    const parentIds = (0, react_1.useMemo)(() => (0, utils_1.getNodesWithChildren)(hierarchalTree), [hierarchalTree]);
    const getTitle = (0, react_1.useCallback)(({ subCategory }) => {
        const isCategoryUncategorized = subCategory.id === const_1.UNCATEGORIZED_ID;
        const title = isCategoryUncategorized ? (t({ key: 'UNCATEGORIZED' })) : subCategory.title;
        return title;
    }, [t]);
    const getCategoryLevelChildren = (0, react_1.useCallback)((categories, level) => {
        const childrenMap = new Map();
        [...categories.values()].forEach((category) => {
            category.subcategoryIds.forEach((subCategoryId) => {
                const subCategory = categoriesMap[subCategoryId];
                childrenMap.set(subCategoryId, Object.assign(Object.assign({}, subCategory), { parentId: level, children: new Map(), title: getTitle({ subCategory }) }));
            });
        });
        return childrenMap;
    }, [categoriesMap]);
    const categoryLevelsTree = (0, react_1.useMemo)(() => {
        const categoryLevelsMap = new Map();
        let categoryLevel = 1;
        let subCategories = new Map(topLevelCategories.map((category) => [category.id, Object.assign(Object.assign({}, category), { parentId: `${categoryLevel}`, children: new Map() })]));
        while (subCategories.size > 0) {
            const title = t({ key: 'CATEGORY_LEVEL', values: { level: categoryLevel } });
            const id = `${categoryLevel}`;
            categoryLevelsMap.set(id, {
                title,
                children: subCategories,
                parentId: null,
                id,
            });
            categoryLevel++;
            subCategories = getCategoryLevelChildren(subCategories, `${categoryLevel}`);
        }
        return categoryLevelsMap;
    }, [topLevelCategories, t, getCategoryLevelChildren]);
    const commonProps = {
        excluded: excludedCategoriesIds,
        included: includedCategoriesIds,
        expandOverride,
        setExcluded: handleSetExclude,
        setIncluded: handleSetInclude,
        debouncedSearchTerm,
    };
    return isSimple ? (react_1.default.createElement(tree_navigation_1.TreeNavigation, Object.assign(Object.assign({}, commonProps), { treeData: categoryLevelsTree, parentIds: Array.from({ length: categoryLevelsTree.size }, (_, index) => (index + 1).toString()), terminalNodeInteractionOnly: true, simpleRootNode: true }))) : (react_1.default.createElement(tree_navigation_1.TreeNavigation, Object.assign(Object.assign({}, commonProps), { treeData: hierarchalTree, parentIds: parentIds })));
};
exports.CategoriesFacetNavigation = CategoriesFacetNavigation;
exports.default = exports.CategoriesFacetNavigation;
